// extracted by mini-css-extract-plugin
export var hero = "hero-module--hero--25w3J";
export var txthero = "hero-module--txthero--2qYON";
export var pone = "hero-module--pone--3L3l7";
export var spanone = "hero-module--spanone--GZxJi";
export var buttoncontact = "hero-module--buttoncontact--p8_-O";
export var bounce = "hero-module--bounce--1i-0f";